import { render, staticRenderFns } from "./ObiRow.vue?vue&type=template&id=1ea4281e&scoped=true&"
import script from "./ObiRow.vue?vue&type=script&lang=js&"
export * from "./ObiRow.vue?vue&type=script&lang=js&"
import style0 from "./ObiRow.vue?vue&type=style&index=0&id=1ea4281e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea4281e",
  null
  
)

export default component.exports